import React, { useEffect, useState } from 'react';
import { ProcessExecutionService } from '@services/actions/ProcessExecutionService';
import { IAbookTab } from '@models/Forms/IForms';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import { IChangeControllerProps } from './IChangeControllerProps';
import { IChangeControllerFormData } from './IChangeControllerFormData';
import AbookpickerControl from '@controls/AbookpickerControl';

export const ChangeControllerModal: React.FC<IChangeControllerProps> = (props: IChangeControllerProps) => {
    const [controllerDisplayName, setControllerDisplayName] = useState<string>('');
    const [errorText, setErrorText] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const activated = React.useRef(false);

    const serv = new ProcessExecutionService();

    let tabSettings = {
        name: 'Сотрудники',
        mode: 'list',
        child: 'Person',
        columns: [
            { key: 'fullName', name: 'Наименование', width: '', allowSort: true },
            { key: 'email', name: 'Email', width: '' },
        ],
        cache: JSON.stringify({
            name: 'Сотрудники',
            mode: 'list',
            child: 'Person',
        }),
    } as IAbookTab;

    const onSubmit = (form: IChangeControllerFormData) => {
        if (!form?.controller) {
            setErrorText('Не указан контролирующий');
            return;
        }

        setLoading(true);
        return serv
            .saveChangeController(props.processId, form?.controller)
            .then((res) => {
                setLoading(false);
                props.completeHandler && props.completeHandler(true);
            })
            .catch((err) => {
                setErrorText(err);
            })
            .finally(() => setLoading(false));
    };

    const formState = useForm<IChangeControllerFormData>({
        mode: 'onBlur', // "onChange"
    });

    useEffect(() => {
        setLoading(true);
        activated.current = true;

        serv.getChangeControllerModel(props.processId)
            .then((res) => {
                setControllerDisplayName(res.data.controllerFullName);
                formState.reset({ controller: res.data.controllerKey } as IChangeControllerFormData);
                setLoading(false);
            })
            .catch((err) => {
                setErrorText('Ошибка получения данных от сервера.');
            })
            .finally(() => setLoading(false));
        return () => {
            activated.current = false;
        };
    }, []);

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        isBusy: loading,
        cancelClick: () => {
            props.completeHandler && props.completeHandler(false);
        },
        errorText: errorText,
        formMethods: formState,
        onSubmit: onSubmit,
        okButtonDisabled: false,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <AbookpickerControl
                label="Контролирующий по маршруту"
                placeholder="Выберите пользователя из адресной книги"
                isMultiple={false}
                title="Контролирующий по маршруту"
                displayValue={controllerDisplayName}
                formValues={'{}'}
                name="controller"
                tabsSettings={[tabSettings]}
                required
                formState={formState.formState}
                showChips={false}
                control={formState.control}
                onSetValues={(value: IAddressBookData[]) => {
                    setControllerDisplayName(value[0].fullName);
                }}
            />
        </ModalContainer>
    );
};
